
export const transitRoutes = [
  {
    id: 1,
    name: 'Route A - Galleria Express',
    type: 'Local',
    color: '#14B8A6',
    description: 'Connects downtown to Westfield Galleria via Douglas Blvd',
    stops: ['Downtown Transit Center', 'Civic Center', 'Sierra Gardens', 'Westfield Galleria'],
    frequency: 'Every 20 min',
    hours: '6:00 AM - 10:00 PM'
  },
  {
    id: 2,
    name: 'Route B - Blue Oaks Loop',
    type: 'Local',
    color: '#3B82F6',
    description: 'Serves Blue Oaks, Fiddyment, and Pleasant Grove areas',
    stops: ['Galleria', 'Blue Oaks Town Center', 'Fiddyment Farm', 'Pleasant Grove'],
    frequency: 'Every 30 min',
    hours: '6:30 AM - 9:00 PM'
  },
  {
    id: 3,
    name: 'Route C - Cirby/Sunrise',
    type: 'Local',
    color: '#F59E0B',
    description: 'East-west route along Cirby Way and Sunrise Ave',
    stops: ['Downtown', 'Mahany Park', 'Sunrise Mall', 'Citrus Heights'],
    frequency: 'Every 25 min',
    hours: '6:00 AM - 9:30 PM'
  },
  {
    id: 4,
    name: 'Route D - Douglas Blvd',
    type: 'Local',
    color: '#EC4899',
    description: 'Main corridor connecting Roseville to Granite Bay',
    stops: ['Downtown Transit', 'Sierra College Blvd', 'Eureka Rd', 'Granite Bay'],
    frequency: 'Every 30 min',
    hours: '6:00 AM - 8:00 PM'
  },
  {
    id: 5,
    name: 'Sacramento Commuter',
    type: 'Commuter',
    color: '#8B5CF6',
    description: 'Express service to downtown Sacramento via I-80',
    stops: ['Roseville Transit Center', 'Sacramento Valley Station'],
    frequency: 'Every 30 min (Peak)',
    hours: '5:30 AM - 7:30 PM'
  },
  {
    id: 6,
    name: 'Dial-A-Ride',
    type: 'On-Demand',
    color: '#10B981',
    description: 'Door-to-door service for seniors and disabled residents',
    stops: ['Citywide Coverage'],
    frequency: 'On Request',
    hours: '7:00 AM - 6:00 PM'
  }
];

export const parkingLocations = [
  {
    id: 1,
    name: 'Downtown Parking Garage',
    type: 'Garage',
    address: '400 Vernon Street',
    spaces: 650,
    rate: 'Free (2 hrs) / $1/hr after',
    hours: '24/7',
    features: ['EV Charging', 'Covered', 'Security Cameras'],
    icon: 'ri-building-2-line'
  },
  {
    id: 2,
    name: 'Civic Center Lot',
    type: 'Surface Lot',
    address: '316 Vernon Street',
    spaces: 200,
    rate: 'Free',
    hours: '6:00 AM - 10:00 PM',
    features: ['ADA Accessible', 'Well Lit'],
    icon: 'ri-parking-box-line'
  },
  {
    id: 3,
    name: 'Westfield Galleria Parking',
    type: 'Garage',
    address: '1151 Galleria Blvd',
    spaces: 6000,
    rate: 'Free',
    hours: 'Mall Hours',
    features: ['Covered', 'EV Charging', 'Valet Available'],
    icon: 'ri-building-2-line'
  },
  {
    id: 4,
    name: 'Royer Park Lot',
    type: 'Surface Lot',
    address: '200 Park Drive',
    spaces: 150,
    rate: 'Free',
    hours: 'Dawn - Dusk',
    features: ['Near Trails', 'Restrooms Nearby'],
    icon: 'ri-parking-box-line'
  },
  {
    id: 5,
    name: 'Transit Center Park & Ride',
    type: 'Park & Ride',
    address: '250 Confluence Drive',
    spaces: 300,
    rate: 'Free',
    hours: '24/7',
    features: ['Transit Access', 'Long-term OK', 'Security Patrol'],
    icon: 'ri-bus-line'
  },
  {
    id: 6,
    name: 'Old Town Street Parking',
    type: 'Street',
    address: 'Atlantic Street & Lincoln Street',
    spaces: 100,
    rate: 'Free (2 hr limit)',
    hours: '8:00 AM - 6:00 PM',
    features: ['Historic District', 'Near Shops'],
    icon: 'ri-road-map-line'
  }
];

export const transportationTips = [
  {
    icon: 'ri-smartphone-line',
    title: 'Roseville Transit App',
    description: 'Download the free app for real-time bus tracking and trip planning'
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Clipper Card',
    description: 'Use Clipper for seamless transfers between Roseville Transit and Sacramento RT'
  },
  {
    icon: 'ri-bike-line',
    title: 'Bike Racks',
    description: 'All Roseville buses are equipped with front-mounted bike racks'
  },
  {
    icon: 'ri-wheelchair-line',
    title: 'Accessibility',
    description: 'All buses are ADA accessible with wheelchair lifts and priority seating'
  }
];

export const fares = [
  { type: 'Single Ride', price: '$1.50', note: 'Cash or Clipper' },
  { type: 'Day Pass', price: '$4.00', note: 'Unlimited rides' },
  { type: 'Monthly Pass', price: '$50.00', note: 'Best value' },
  { type: 'Senior/Disabled', price: '$0.75', note: 'With valid ID' },
  { type: 'Youth (5-18)', price: '$1.00', note: 'Student ID required' },
  { type: 'Children Under 5', price: 'Free', note: 'With paying adult' }
];
